import React from "react";
import { Container, Grid, Paper, Box } from "@mui/material";
import Layout from "../Layout";
import useSession from "../../effects/useSession";
import pageStyles from "../pageStyles";
import PageHeading from "../../common/pageHeading/PageHeading";
import AuditTable from "./auditTable/AuditTable";

export default function Audit(): React.ReactElement {
  const classes = pageStyles();
  const session = useSession();

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={`${classes.container}`}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="Audit Log" entity="AuditTrail" />
              </Paper>
              <Box my={2}>
                <Paper>
                  <AuditTable />
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
